import React, { createContext, useContext, useState } from "react";

const ScorecardContext = createContext(null);

export function ScorecardProvider({ children }) {
  const [scores, setScores] = useState({});
  const setMetricScore = (storeId, pillarIndex, metricIndex, value) => {
    setScores((prev) => ({
      ...prev,
      [storeId]: {
        ...(prev[storeId] || {}),
        [`${pillarIndex}-${metricIndex}`]: value,
      },
    }));
  };
  return (
    <ScorecardContext.Provider value={{ scores, setMetricScore }}>
      {children}
    </ScorecardContext.Provider>
  );
}

export function useScorecard() {
  const context = useContext(ScorecardContext);
  if (!context) throw new Error("useScorecard must be used within ScorecardProvider");
  return context;
}
